module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-wacana"
    }
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.makeNew()
      }
    }
  }, [_vm._v("Buat Baru")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), (_vm.wacana != '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editWacana
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.wacana != '') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }, [_vm._v("\n    Reset\n  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.wacana.id != 0) ? _c('blockquote', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewWacana)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        _vm.showModal = false
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cari Wacana")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-datatable', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.wacanas,
      "numbered": false
    },
    on: {
      "selected": function($event) {
        _vm.wacana = $event.data[0]
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? _c('app-modal', {
    on: {
      "ok": _vm.resetWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Perhatian")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Apakah anda yakin ingin melepas wacana ini dari soal?")])])]) : _vm._e(), _vm._v(" "), (_vm.showCreateWacanaModal) ? _c('app-modal', {
    on: {
      "ok": _vm.saveWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Buat Wacana Baru")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.wacana
    },
    on: {
      "content-updated": function($event) {
        _vm.wacana = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWacana()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateWacanaModal = false
      }
    }
  }, [_vm._v("Batal")])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3f30a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/free_itembank/FreeWacana.vue
// module id = 1327
// module chunks = 0